import React from 'react';
import { Star, Check, Lock, Download, Zap } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const Hero: React.FC = () => {
  return <section className="pt-6 pb-6 px-4 max-w-3xl mx-auto" data-id="element-81">
      {/* Headlines */}
      <h1 className="font-rounded font-bold text-[2.25rem] sm:text-5xl md:text-6xl text-violet text-center leading-[1.02] mb-3" data-id="element-82">
        ¿Tu hijo pasa demasiado tiempo frente al{' '}
        <span className="text-gold-dark" data-id="element-83">celular</span>?
      </h1>

      <p className="text-base sm:text-lg text-textsoft text-center max-w-2xl mx-auto mb-4 font-semibold leading-snug" data-id="element-84">
        Más de <strong className="text-violet" data-id="element-85">50 libros Disney</strong> y{' '}
        <strong className="text-violet" data-id="element-86">2.500 páginas</strong> listas para
        imprimir para transformar horas de pantalla en creatividad, diversión e
        imaginación.
      </p>

      {/* Stars + social proof */}
      <div className="flex flex-col items-center mb-5" data-id="element-87">
        <div className="flex gap-0.5 mb-1" data-id="element-88">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-dark text-gold-dark" data-id="element-89" />)}
        </div>
        <p className="text-sm font-bold text-textsoft" data-id="element-90">
          Más de{' '}
          <span className="text-violet font-extrabold" data-id="element-91">
            5.000 familias felices
          </span>
        </p>
      </div>

      {/* GIANT Product Image */}
      <div className="w-full mb-5 relative" data-id="element-92">
        <img src="https://cdn.magicpatterns.com/uploads/d4RRdDi26Um4PeNDBwU8ao/colecion_completa.png" alt="Colección completa Biblioteca Mágica Disney - Más de 50 libros" className="w-full h-auto drop-shadow-2xl" data-id="element-93" />
        {/* Floating sticker */}
        <div className="absolute -top-2 -right-2 sm:top-4 sm:right-4 bg-yellow text-violet rounded-full w-20 h-20 sm:w-28 sm:h-28 flex flex-col items-center justify-center font-rounded font-bold shadow-xl border-4 border-white rotate-12" data-id="element-94">
          <span className="text-sm sm:text-base leading-none" data-id="element-95">+50</span>
          <span className="text-[10px] sm:text-xs leading-none mt-1" data-id="element-96">
            LIBROS
          </span>
        </div>
      </div>

      {/* Premium Price block */}
      <div className="bg-white rounded-2xl border-[3px] border-dashed border-gold px-5 py-5 mb-5 text-center shadow-card" data-id="element-97">
        <p className="text-[11px] uppercase tracking-widest text-textsoft font-extrabold mb-3" data-id="element-98">
          Precio especial por tiempo limitado
        </p>
        <div className="flex flex-col items-center gap-1 mb-2" data-id="element-99">
          <div className="flex items-baseline gap-2" data-id="element-100">
            <span className="text-xs uppercase tracking-wider text-textsoft font-bold" data-id="element-101">
              Valor real:
            </span>
            <span className="text-gray-400 line-through text-xl font-bold" data-id="element-102">
              $89.990
            </span>
          </div>
          <div className="flex items-baseline gap-2" data-id="element-103">
            <span className="text-xs uppercase tracking-wider text-violet font-extrabold" data-id="element-104">
              Hoy:
            </span>
            <span className="font-rounded font-bold text-4xl text-violet leading-none" data-id="element-105">
              $19.990
            </span>
          </div>
        </div>
        <div className="inline-block bg-brandgreen/15 text-brandgreen rounded-full px-3 py-1 text-sm font-extrabold mt-1" data-id="element-106">
          🎉 Ahorrás $70.000
        </div>
      </div>

      <CTAButton subtext="Acceso inmediato · Descarga digital · Pago seguro" data-id="element-107" />
    </section>;
};